export const RuntimeOrderStatus_Pending = 'PENDING';
export const RuntimeOrderStatus_Accepted = 'ACCEPTED';
export const RuntimeOrderStatus_Resulted = 'RESULTED';
export const RuntimeOrderStatus_PendingSignature = 'PENDING-SIGNATURE';
export const RuntimeOrderStatus_Recommended = 'RECOMMENDED';
export const RuntimeOrderStatus_FoundInFhir = 'FOUND_IN_FHIR';
export const RuntimeOrderStatus_Completed = 'COMPLETED';
export const RuntimeOrderStatus_Enum = {
    PENDING: RuntimeOrderStatus_Pending,
    ACCEPTED: RuntimeOrderStatus_Accepted,
    RESULTED: RuntimeOrderStatus_Resulted,
    PENDING_SIGNATURE: RuntimeOrderStatus_PendingSignature,
    RECOMMENDED: RuntimeOrderStatus_Recommended,
    FOUND_IN_FHIR: RuntimeOrderStatus_FoundInFhir,
    COMPLETED: RuntimeOrderStatus_Completed,
};
// for UI
export const RuntimeOrderStatus_Labels = {
    [RuntimeOrderStatus_Enum.PENDING]: 'Pending',
    [RuntimeOrderStatus_Enum.ACCEPTED]: 'Accepted',
    [RuntimeOrderStatus_Enum.RESULTED]: 'Resulted',
    [RuntimeOrderStatus_Enum.PENDING_SIGNATURE]: 'Pending Signature',
    [RuntimeOrderStatus_Enum.RECOMMENDED]: 'Recommended',
    [RuntimeOrderStatus_Enum.FOUND_IN_FHIR]: 'Pending',
    [RuntimeOrderStatus_Enum.COMPLETED]: 'Completed',
};
export const RuntimeOrderSource_Advisor = 'ADVISOR';
export const RuntimeOrderSource_FHIR = 'FHIR';
export const RuntimeOrderSource_Enum = {
    ADVISOR: RuntimeOrderSource_Advisor,
    FHIR: RuntimeOrderSource_FHIR,
};
export const ApprovalSource_User = 'USER';
export const ApprovalSource_FHIR = 'FHIR';
export const ApprovalSource_Enum = {
    USER: ApprovalSource_User,
    FHIR: ApprovalSource_FHIR,
};
// for UI
export const RuntimeOrderSource_Labels = {
    [RuntimeOrderSource_Enum.ADVISOR]: 'Advisor',
    [RuntimeOrderSource_Enum.FHIR]: 'FHIR'
};
//# sourceMappingURL=consts.js.map